"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactAvatar = require("./ContactAvatar");
Object.keys(_ContactAvatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactAvatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactAvatar[key];
    }
  });
});